import React from "react";
import "./Contact.css";

const Contact = () =>
{
  return (
    <div className="contact">
      <h2>Contact</h2>
      <div className="contactContent">
        <p>
          Connect with me via Gmail.
        </p>
      </div>
      <button onClick={() =>
        window.location = 'mailto:gautamgunecha@gmail.com'}>Send Mail</button>
    </div>
  );
};

export default Contact;
